import { all } from "redux-saga/effects";
import authSagas from "./auth/sagas";
import examSagas from "./exam/sagas";
import feedbackSaga from "./feedback/sagas";
import sampleTestSagas from "./sampleTest/sagas";


export default function* rootSaga() {
  yield all([
    authSagas(),
    examSagas(),
    feedbackSaga(),
    sampleTestSagas()
  ]);
}
